export default __webpack_public_path__ + "images/icons/pin-a-516036b4fcd0157bf9b518b91d640c51.svg";